import React from "react";
import {Link} from "react-router";

export default class ObjectInfo extends React.Component {
    render () {
        const url = `/${this.props.params.client}/${this.props.params.widget}/map/${this.props.params.id}`;

        const object = this.props.data.objects.data.find(obj => {
            return obj.number === this.props.params.number;
        });

        var coordinates = object.data['balcony_view'].split(';');

        return (
            <div className="cw-object-info-main">
                <div className="containers">
                    <div className="cw-object-info-wrapper">
                        <div className="cw-object-info-data">
                            <div className="cw-object-info-heading">Lgh {object.number}</div>
                            <div className="cw-object-info-data-body">
                                <table className="cw-object-info-table">
                                    <tbody>
                                    <tr><th>Våning:</th><td>{object.data['floor_number']}</td></tr>
                                    <tr><th>Rum:</th><td>{object.data['rooms']} rok</td></tr>
                                    <tr><th>Boarea:</th><td>{object.data['living_area']} m<sup>2</sup></td></tr>
                                    {object.data['usp1'] && <tr><th>Inredningsval:</th><td>{object.data['usp1']}</td></tr>}
                                    {object.data['price'] && <tr><th>Pris:</th><td>{object.data['price'].formatted}</td></tr>}
                                    {object.data['monthly_fee'] && <tr><th>Avgift:</th><td>{object.data['monthly_fee'].formatted}</td></tr>}
                                    <tr><th>Status:</th><td><span className={'status-blob status-blob-'+object.status}></span> {object.status_name}</td></tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="cw-object-info-data-footer">
                                <Link to={object.resource_urls.pdf} target="_new">Bofaktablad</Link>
                                <Link to={url}>Tillbaka</Link>
                            </div>
                        </div>
                        <div className="cw-object-info-plan">
                            <div className="plan-container">
                                <img className="plan-image" src={object.resource_urls.plan} alt="Planritning"/>
                                {coordinates.map((coordinate, i) => {

                                    if (coordinate !== '') {

                                        var xy = coordinate.split(',');
                                        var suffix = '';

                                        if (i > 0 ) {
                                            suffix = '-' + (i+1);
                                        }

                                        var divStyle = {
                                            left: xy[0] + '%',
                                            top: xy[1] + '%'
                                        };

                                        return (
                                            <a key={'coordinate' + i} className="icon" href={object.resource_urls.balcony + suffix} style={divStyle}>
                                                <p className="iconText">180°</p>
                                            </a>
                                        )
                                    }
                                    else return null;
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ObjectInfo.jsx